/**
 * Filtry listy faktur z KSeF: zakres dat (szybkie wybory 30/90 dni/biezacy rok/caly czas + od/do),
 * status (liczniki z podsumowanie.statusy / razem), rodzaj faktury (liczniki z podsumowanie.rodzaje[kod].liczba),
 * NIP sprzedawcy (backend filtruje po cyfrach NIP), szukaj po numerze faktury / numerze KSeF / nazwie sprzedawcy.
 *
 * Zaznaczony szybki zakres = PELNE tlo + kolor #fff ustawione INLINE - motyw wymusza !important
 * na przyciskach, a wyjatek :not([style*="background"]) w v3sys-theme.css dziala tylko dla inline
 * background. Nie zamieniac na klasy.
 */
import React from 'react';
import { SZYBKIE_ZAKRESY, dzisISO, STATUSY, RODZAJE } from './format';

const WSZYSTKIE = '';
const pole = { padding: '4px 8px', fontSize: '11px', borderRadius: '4px', border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)', color: 'var(--text)' };
const etykieta = { fontSize: '11px', color: 'var(--text-secondary)', whiteSpace: 'nowrap' };

export const ZakresDat = ({ zakres, onZmiana, zablokowane }) => {
  const dzis = dzisISO();
  const aktywny = SZYBKIE_ZAKRESY.find(z => z.od() === zakres.od && zakres.do === dzis)?.id || null;
  return (
    <div data-testid="zakres-dat" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
      <span style={{ color: 'var(--text-secondary)', fontWeight: 600 }}>Zakres</span>
      <div role="group" aria-label="Szybki zakres" style={{ display: 'flex', gap: '6px' }}>
        {SZYBKIE_ZAKRESY.map(z => {
          const jest = z.id === aktywny;
          return (
            <button key={z.id} type="button" data-testid={`zakres-${z.id}`} aria-pressed={jest} disabled={zablokowane}
              onClick={() => onZmiana({ od: z.od(), do: dzis })}
              style={{
                padding: '4px 10px', fontSize: '11px', fontWeight: 600, borderRadius: '12px', cursor: 'pointer',
                border: '1px solid var(--primary)',
                background: jest ? 'var(--primary)' : 'var(--card-bg)',
                color: jest ? '#fff' : 'var(--primary)',
              }}>
              {z.etykieta}
            </button>
          );
        })}
      </div>
      <label style={etykieta}>
        od{' '}
        <input type="date" aria-label="Data od" value={zakres.od || ''} max={zakres.do || dzis} disabled={zablokowane}
          onChange={(e) => e.target.value && onZmiana({ ...zakres, od: e.target.value })} style={pole} />
      </label>
      <label style={etykieta}>
        do{' '}
        <input type="date" aria-label="Data do" value={zakres.do || ''} min={zakres.od || undefined} max={dzis} disabled={zablokowane}
          onChange={(e) => e.target.value && onZmiana({ ...zakres, do: e.target.value })} style={pole} />
      </label>
    </div>
  );
};

/**
 * Props: status (null = wszystkie), rodzaj (null = wszystkie), nip (tekst), szukaj (numer faktury / KSeF / sprzedawca),
 * zakres, statusy + razem (z podsumowania - liczniki w opcjach), rodzaje ({kod: {liczba, brutto}}).
 */
const FiltryKsef = ({ status, onStatus, rodzaj, onRodzaj, nip, onNip, szukaj, onSzukaj, zakres, onZakres, statusy, razem, rodzaje, zablokowane }) => {
  const l = statusy || {};
  const r = rodzaje || {};
  const licznikRodzaju = (kod) => (r[kod] && r[kod].liczba !== undefined ? ` (${r[kod].liczba})` : '');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '12px' }}>
      <ZakresDat zakres={zakres} onZmiana={onZakres} zablokowane={zablokowane} />
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' }}>
        <label style={etykieta}>
          Status{' '}
          <select aria-label="Status" data-testid="filtr-status" value={status || WSZYSTKIE}
            onChange={(e) => onStatus(e.target.value === WSZYSTKIE ? null : e.target.value)} style={pole}>
            <option value={WSZYSTKIE}>wszystkie statusy{razem !== undefined && razem !== null ? ` (${razem})` : ''}</option>
            {Object.entries(STATUSY).map(([kod, s]) => (
              <option key={kod} value={kod}>{s.etykieta}{l[kod] !== undefined ? ` (${l[kod]})` : ''}</option>
            ))}
          </select>
        </label>
        <label style={etykieta}>
          Rodzaj{' '}
          <select aria-label="Rodzaj faktury" data-testid="filtr-rodzaj" value={rodzaj || WSZYSTKIE}
            onChange={(e) => onRodzaj(e.target.value === WSZYSTKIE ? null : e.target.value)} style={pole}>
            <option value={WSZYSTKIE}>wszystkie rodzaje</option>
            <option value="korekty">wszystkie korekty</option>
            {Object.entries(RODZAJE).map(([kod, x]) => (
              <option key={kod} value={kod}>{x.pelna}{licznikRodzaju(kod)}</option>
            ))}
          </select>
        </label>
        <input type="search" value={nip} onChange={(e) => onNip(e.target.value)} placeholder="NIP sprzedawcy…"
          aria-label="NIP sprzedawcy" data-testid="filtr-nip" style={{ ...pole, minWidth: '160px' }} />
        <input type="search" value={szukaj} onChange={(e) => onSzukaj(e.target.value)} placeholder="Szukaj: numer faktury / KSeF / sprzedawca…"
          aria-label="Szukaj po numerze" data-testid="filtr-szukaj" style={{ ...pole, marginLeft: 'auto', minWidth: '260px' }} />
      </div>
    </div>
  );
};

export default FiltryKsef;
